import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiEndpoints } from '@core/constants';
import { MemberSearchResponse, SearchRequestParam, UserInfo, MyOrganization } from '@core/models';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import Helper from '@shared/utils/Helper';
import { SessionSecurityService } from '@shared/services'

@Injectable({
  providedIn: 'root'
})
export class MemberSearchService {
  httpOptions = {
    headers: new HttpHeaders({ 'spinner': 'no' })
  };
  cache = {};

  //Behaviour subject to call me api after initialising user id
  private isUserInfoAvailable: BehaviorSubject<boolean>;

  constructor(private http: HttpClient, private sessionSecurity: SessionSecurityService) {
    this.isUserInfoAvailable = new BehaviorSubject<boolean>(false);
  }

  getMembersInfo(searchRequestParam: SearchRequestParam): Observable<MemberSearchResponse[]> {
    return this.http.post<MemberSearchResponse[]>(ApiEndpoints.getMembers, searchRequestParam)
      .pipe(
        catchError(this.handleError<MemberSearchResponse[]>('getMembersInfo', []))
      );
  }


  getMyInfo(code:string){
    if (this.cache[code]) {
      return this.cache[code];
    }
    else {
      let meValue = this.sessionSecurity.getObject<UserInfo>("me_"+code);
      if(Helper.isNullOrEmpty(meValue)){
        this.cache[code] =  this.http.get<UserInfo>(ApiEndpoints.getMyInfo)
          .pipe(
            map((res) => {
              if(Helper.hasAny(res) && Helper.hasAny(res.id)) {
                this.sessionSecurity.setObject<UserInfo>(res, 'me_'+res.id);
              }
              return res;
            }),
            catchError(err => {
              delete this.cache[code];
              return '';
            })
          );

        return this.cache[code];        
      }
      else {
        return new Observable((observer) => {
          setTimeout(() => {
            observer.next(meValue);
          }, 300);
        });
      }      
    }
    
    /**
     * Old Implementation
     */
    
    /*
    this.cache[code] =  this.http.get<UserInfo>(ApiEndpoints.getMyInfo)
      .pipe(
        catchError(err => {
          delete this.cache[code];
          return '';
        })
      );

      return this.cache[code];
    */
  }
  
  getMyUpdateInfo() {
    return this.http.get<UserInfo>(ApiEndpoints.getMyInfo).pipe(
        map((res) => {
          if(Helper.hasAny(res) && Helper.hasAny(res.id)) {
            this.sessionSecurity.setObject<UserInfo>(res, 'me_'+res.id);
          }          
          return res;
        }),
        catchError(this.handleError<UserInfo>('getUpdateMembersInfo'))
      );
  }
  // getMyNotificationUpdateInfo() {
  // return this.http.get<UserNotificaitons>(ApiEndpoints.getNotificationCount).pipe(
  //       map((result) => {
  //         if(Helper.hasAny(result) && Helper.hasAny(result)) {
  //           this.sessionSecurity.setObject<UserNotificaitons>(result, 'me_'+result);
  //         }          
  //         return result;
  //       }),
  //       catchError(this.handleError<UserNotificaitons>('getMyNotificationUpdateInfo'))
  //     );
  // }
  getNotificationCount() {
    return this.http.get<UserInfo>(ApiEndpoints.getNotificationCount)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(this.handleError<any>('getNotificationCount'))
      );
  }

  getDODOrganizations(): Observable<MyOrganization[]> {
    let organizations =
      this.sessionSecurity.getObject<MyOrganization[]>('DODOrganizations');

    if (Helper.isNullOrEmpty(organizations)) {
      return this.http
        .get<MyOrganization[]>(ApiEndpoints.getDODOrganizations)
        .pipe(
          map((res) => {
            if (Helper.hasAny(res)) {
              this.sessionSecurity.setObject<MyOrganization[]>(
                res,
                'DODOrganizations'
              );
            }
            return res;
          }),
          catchError(
            this.handleError<MyOrganization[]>('getDODOrganizations', [])
          )
        );
    } else {
      return new Observable((observer) => {
        setTimeout(() => {
          observer.next(organizations);
        }, 300);
      });
    }
  }


  updateCEOAssignApplicationRole(request) {
    return this.http.post(ApiEndpoints.updateCEOAssignApplicationRole, request)
      .pipe(
        catchError(this.handleError('updateCEOAssignApplicationRole', []))
      );
  }


  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      console.error(error); // log to console instead
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  //Functions to get/set value for behaviour subject
  setUserInfoValue(newValue): void {
    this.isUserInfoAvailable.next(newValue);
  }

  getUserInfoValue(): Observable<boolean> {
    return this.isUserInfoAvailable.asObservable();
  }


updatePopupIgnoreValue(value) {
return this.http.put(ApiEndpoints.updatePopupIgnoreValue +`${value}`,value);
  }
}
